import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AsamcoUserService } from '@asamco/base';
import { showErrorSwal } from '@asamco/utils';
import { Observable, Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { FunctionAppInstance } from '../interfaces/function-app-instance.interface';
import { FunctionAppService } from '../services/function-app.service';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DxoSelectionModule, DxoFilterRowModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxDataGridModule } from 'devextreme-angular';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-shell-functionappmanagement',
    templateUrl: './functionappmanagement.component.html',
    styleUrls: ['./functionappmanagement.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, DxDataGridModule, DxoSelectionModule, DxoFilterRowModule, DxiColumnModule, DxTemplateModule, AsyncPipe]
})
export class FunctionappmanagementComponent implements OnInit {

  public canManageFunctionAppsSubject = new Subject<boolean>();
  public canManageFunctionAppsObservable = this.canManageFunctionAppsSubject.asObservable();
  private instances: FunctionAppInstance[] = [];

  private dataSubject = new Subject<FunctionAppInstance[]>(); 
  public dataObservable = this.dataSubject.asObservable();

  constructor(private asamcoUserService: AsamcoUserService, private functionAppService: FunctionAppService) { }

  killInstance(e: FunctionAppInstance)
  {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.functionAppService.terminateSingleInstance(e.instanceId).subscribe(e => { 
          Swal.fire(
          'Terminated instance!',
          'Successfully terminated instance.',
          'success'
        ) }, err => {
          Swal.fire(
            'Error terminating instance',
            'Unable to terminate instance.',
            'error'
          )}
        );

      }
    })
  }

  purgeHistory(e)
  {
    this.functionAppService.purgeHistorySingleInstance(e.instanceId).subscribe(e => { 

    }, err => showErrorSwal(err))
  }

  retrieveData() {
    this.functionAppService.getAllInstances().subscribe((e: any[]) => 
    {
      if(e)
      {
        e.forEach(item => {
          let functionAppInstance: FunctionAppInstance = {
            name: item.name,
            instanceId: item.instanceId,
            runtimeStatus: item.runtimeStatus,
            linkId: item.input?.LinkId,
            customStatus: item.customStatus,
            output: item.output,
            createdTime: item.createdTime,
            lastUpdatedTime: item.lastUpdatedTime,
          };
          this.instances.push(functionAppInstance);
        })
        this.dataSubject.next(this.instances);
      }
   }, err => showErrorSwal(err))
  }

  ngOnInit(): void {
    this.asamcoUserService.hasAssignedPermission('AL3_FUNC_APP').then(result =>  { this.canManageFunctionAppsSubject.next(result); if (!result) return; this.retrieveData()});
  }


}
